import {
  Baby,
  Briefcase,
  Building2,
  Car,
  Dumbbell,
  Gamepad2,
  LayoutGrid,
  Laptop,
  PawPrint,
  Shirt,
  Smartphone,
  Sofa,
  Sparkles,
  Tv,
  Wheat,
  Wrench,
  type LucideIcon,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  Smartphone,
  Tv,
  Laptop,
  Shirt,
  Sparkles,
  Sofa,
  Car,
  Building2,
  Baby,
  Briefcase,
  Wrench,
  Wheat,
  Dumbbell,
  Gamepad2,
  PawPrint,
};

/** Lucide icon by the name stored on Category.icon (falls back to a grid). */
export function CategoryIcon({ name, className }: { name?: string | null; className?: string }) {
  const Icon = (name && ICONS[name]) || LayoutGrid;
  return <Icon className={className} aria-hidden />;
}
